export default __webpack_public_path__ + "static/media/06_COSMOS.4a4e6674.png";